import React from "react";
import { Card, CardBody, Row, Col, Badge, Button } from "reactstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import UserIcon from '../Assets/images/user.png';
import { formatIST } from "../Helpers/Utils";

const UserProfile = () => {

    const user = useSelector(s => s.customer.customer);
    const navigate = useNavigate();

    if (!user) return null;

    const roleColor = {
        admin: "primary",
        manager: "success",
        staff: "secondary"
    };

    return (
        <>
            {/* HEADER */}
            <Row className="mb-4 align-items-center">
                <Col>
                    <h4 className="fw-bold mb-1">User Profile</h4>
                    <small className="text-muted">Logged in account details</small>
                </Col>
                <Col className="text-end">
                    <Button color="light" onClick={() => navigate(-1)}>
                        <i className="bx bx-arrow-back"></i> Back
                    </Button>
                </Col>
            </Row>

            {/* PROFILE CARD */}
            <Card className="shadow-sm">
                <CardBody>

                    <Row className="mb-4 align-items-center">
                        <Col md={2} className="text-center">
                            <img className="user-avatar-big" src={UserIcon} alt="user" />
                            <div>
                                <Badge color={roleColor[user.role] || "dark"}>
                                    {user.role.toUpperCase()}
                                </Badge>
                            </div>
                        </Col>

                        <Col md={10}>
                            <h5 className="fw-bold mb-1 text-capitalize">
                                {user.name}
                            </h5>
                            <div className="text-muted">{user.email}</div>
                        </Col>
                    </Row>

                    <hr />

                    {/* DETAILS */}
                    <Row className="g-4">
                        <Col md={4}>
                            <small className="text-muted">User ID</small>
                            <div className="fw-semibold">{user.id}</div>
                        </Col>

                        <Col md={4}>
                            <small className="text-muted">Organisation ID</small>
                            <div className="fw-semibold">{user.org_id}</div>
                        </Col>

                        <Col md={4}>
                            <small className="text-muted">Outlet ID</small>
                            <div className="fw-semibold">{user.outlet_id}</div>
                        </Col>

                        <Col md={4}>
                            <small className="text-muted">Role</small>
                            <div className="fw-semibold text-capitalize">{user.role}</div>
                        </Col>

                        <Col md={4}>
                            <small className="text-muted">Email</small>
                            <div className="fw-semibold">{user.email}</div>
                        </Col>

                        <Col md={4}>
                            <small className="text-muted">Account Created</small>
                            <div className="fw-semibold">
                                {/* {new Date(user.created_at).toLocaleString()} */}
                                {formatIST(user?.created_at)}
                            </div>
                        </Col>
                    </Row>

                </CardBody>
            </Card>
        </>
    );
};

export default UserProfile;
